import dayjs from "dayjs";
import {EntityBase} from "../../shared/entity/EntityBase";
import {OPERATION_TYPE_TRIGGER, WEEKDAY_ALL} from "../../shared/utils/enum";
import {toUnixTime} from "../../shared/utils/dayjsUtil";

const EVENT_FIELDS = {
    seq: { type: (v) => parseInt(v) || 0, defaultValue: 0 },
    eventIndex: { type: Number, defaultValue: 1 },
    eventType: { defaultValue: '' },
    typeIndex: { type: Number, defaultValue: 0 },
    loadTableIdx: { type: Number, defaultValue: 1 },
    rewardGroup: { type: Number, defaultValue: 0 },
    openLevel: { type: Number, defaultValue: 0 },
    begin: { type: toUnixTime, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: toUnixTime, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    itemIdx: { type: Number, defaultValue: 0 },
    itemMultiple: { type: Number, defaultValue: 0 },
    action: { type: Number, defaultValue: 0 },
    operationType: { type: Number, defaultValue: 1 },
    onTime: { type: Number, defaultValue: 1 },
    arrived: { type: Number, defaultValue: 1 },
    startTime: { type: Number, defaultValue: 0 },
    surpriseTime: { type: Number, defaultValue: 0 },
    memo: { defaultValue: '' },
    onOff: { type: Number, defaultValue: 0 },
    maxLevel: { type: Number, defaultValue: 999 },
    openVersion: { defaultValue: '' },
    cooldownMinutes: { type: Number, defaultValue: 0 },
    dailyMaxCount: { type: Number, defaultValue: 0 },
    triggers: { type: Array, defaultValue: [] },
    weekdays: { type: Number, defaultValue: WEEKDAY_ALL },
    // 세그먼트 이벤트(event_segment_master) 전용. 일반 이벤트 저장 시엔 서버가 무시한다.
    segmentIdx: { type: Number, defaultValue: 0 },
}

export class EventEntity extends EntityBase{
    constructor(data = {}) {
        super(data, EVENT_FIELDS);
        this.errors = [
            { condition: () => !this.begin || !this.end, message: '시작일/종료일 형식이 올바르지 않습니다.' },
            { condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.' },
            { condition: () => this.end < dayjs().unix(), message: '종료일이 현재 시간보다 이전입니다.' },
            { condition: () => this.operationType === OPERATION_TYPE_TRIGGER && this.triggers.length === 0, message: '선행 조건을 1개 이상 설정하세요.' },
            { condition: () => this.operationType === OPERATION_TYPE_TRIGGER && this.triggers.some(t => !t.targetId || !(t.count > 0)), message: '선행 조건의 대상과 수치를 확인하세요.' },
            { condition: () => this.operationType === OPERATION_TYPE_TRIGGER && this.triggers.some(t => t.type === 1 && t.targetId === this.typeIndex), message: '자기 자신을 선행 조건으로 지정할 수 없습니다.' },
            { condition: () => this.operationType === OPERATION_TYPE_TRIGGER && !(this.weekdays > 0), message: '발동 가능 요일을 1개 이상 선택하세요.' },
        ];
    }

    getIdentityKey() {
        return 'seq';
    }
}
